export default __webpack_public_path__ + "static/login_4-208b207a6aabf887f87ea616e7c474a2.gif";